<ng-container *transloco="let t">
  <form [formGroup]="guestCheckoutForm" class="guest-checkout-container" (ngSubmit)="onSubmit()">
    <div class="primary-container">
      <span>
        <span class="account-label">{{t('shared_components.signing_forms.guest_checkout_form.already_have_account')}}</span>
        <button class="button-clear sign-in-button" (click)="onBackToSignInClicked()">{{t('shared_components.signing_forms.guest_checkout_form.sign_in')}}</button>
      </span>
      <div class="input-form">
        <div class="input-wrapper">
          <cwo-input formControlName="firstName" [type]="'text'" [placeholder]="isSelfOrder() ? t('shared_components.signing_forms.guest_checkout_form.name_placeholder') : t('shared_components.signing_forms.guest_checkout_form.first_name_placeholder')" [required]="true" [invalid]="showFirstNameError && firstName.invalid" />
          <div class="errors-wrapper">
            @if(showFirstNameError){
              @if(firstName.hasError('required')){
                <span class="input-error"><cwo-icon class="icon"
                    [name]="iconNameType.error"></cwo-icon>{{isSelfOrder() ? validationMessages.name.required : validationMessages.firstName.required}}</span>
              }
            }
          </div>
        </div>
        @if(!isSelfOrder()){
          <div class="input-wrapper">
            <cwo-input formControlName="lastName" [type]="'text'" [placeholder]="t('shared_components.signing_forms.guest_checkout_form.last_name_placeholder')" [required]="configState().store?.needsLastName ?? false" [invalid]="showLastNameError && lastName.invalid" />
            <div class="errors-wrapper">
              @if(showLastNameError){
                @if(lastName.hasError('required')){
                  <span class="input-error"><cwo-icon class="icon"
                      [name]="iconNameType.error"></cwo-icon>{{validationMessages.lastName.required}}</span>
                }
              }
            </div>
          </div>
          <div class="email-section">
            <span class="email-note">{{ configState().store?.guestCheckoutEmailFieldNote }}</span>
            <div class="input-wrapper">
              <cwo-input formControlName="email" [type]="'email'" [placeholder]="t('shared_components.signing_forms.guest_checkout_form.email_placeholder')" [required]="configState().store?.guestCheckoutEmailPolicy === fieldDisplayPolicy.Require" [invalid]="showEmailError && email.invalid" />
              <div class="errors-wrapper">
                @if(showEmailError && email.invalid){
                  @if(email.hasError('required')){
                    <span class="input-error"><cwo-icon class="icon"
                        [name]="iconNameType.error"></cwo-icon>{{validationMessages.email.required}}</span>
                  }
                  @if(email.hasError('email')){
                    <span class="input-error"><cwo-icon class="icon"
                        [name]="iconNameType.error"></cwo-icon>{{validationMessages.email.email}}</span>
                  }
                }
              </div>
            </div>
          </div>
          <div class="mobile-section">
            <div class="input-wrapper">
              <cwo-mask-field-input formControlName="mobilePhone" [label]="t('shared_components.signing_forms.guest_checkout_form.mobile_phone_label')"
                [maskPattern]="maskFieldInputType.phone" [invalid]="(showMobilePhoneError && mobilePhone.invalid) || !mobilePhoneLength" />
              <div class="errors-wrapper">
                @if(showMobilePhoneError){
                  @if(mobilePhone.hasError('required')){
                    <span class="input-error"><cwo-icon class="icon"
                        [name]="iconNameType.error"></cwo-icon>{{validationMessages.mobilePhone.required}}</span>
                  }
                  @if(!mobilePhoneLength){
                    <span class="input-error"><cwo-icon class="icon"
                        [name]="iconNameType.error"></cwo-icon>{{validationMessages.mobilePhone.mobilePhone}}</span>
                  }
                }
              </div>
            </div>
          </div>
        }
      </div>
      @if(!isSelfOrder()){
        <div class="subscription-form">
          <span>{{t("shared_components.signing_forms.registration_form.receive_offers_and_promotions")}}</span>
          <cwo-toggle-switch formControlName="subscribed" [ariaLabel]="t('shared_components.signing_forms.guest_checkout_form.email_aria_label')" [isChecked]="subscribed.value ?? false"/>
          @if(configState().store?.supportsSmsSubscriptions){
            <div>
              <cwo-toggle-switch formControlName="smsMarketing" [ariaLabel]="t('shared_components.signing_forms.guest_checkout_form.sms_aria_label')" />
              <cwo-sms-sign-up-information />
            </div>
          }
        </div>
      }
      @if(showTableNumberText()){
        <div class="table-number-display">{{t('shared_components.signing_forms.guest_checkout_form.table_number_display_label')}} {{tableNumber()}}</div>
      } @else if(showTableNumberInput()){
        <div class="table-number-wrapper">
          <cwo-input
            [ngModel]="tableNumber()"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="tableNumberChange.emit($event)"
            (focusout)="tableNumberBlur.emit()"
            [type]="'text'"
            [placeholder]="t('shared_components.signing_forms.guest_checkout_form.table_number_placeholder')"
            [required]="true"
            [invalid]="showTableNumberError()"
          />
          @if(showTableNumberError()){
            <span class="input-error">{{validationMessages.tableNumber.required}}</span>
          }
        </div>
      }
    </div>
  </form>
</ng-container>
